<template>
  <div>
    <a-row :gutter="8">
      <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
        <a-card>
          <div slot="title">
            <h4 class="margin-remove">MANIFEST ACCOUNT PAY</h4>
            <small>{{
              datasource.data_header ? datasource.data_header.no_ap : "-"
            }}</small>
          </div>

          <template slot="extra">
            <a-popover
              v-model="visiblemenupopover"
              trigger="click"
              placement="bottom"
            >
              <span slot="title">Select Action</span>
              <ul class="m-list-wrapper bordered" slot="content">
                <li
                  v-if="
                    getAuth.username ==
                      (datasource.data_header
                        ? datasource.data_header.tlc_create
                        : '') || isKeuangan
                  "
                >
                  <a-button
                    :disabled="
                      !(
                        datasource.last_status == 'Revised' &&
                        (getAuth.username ==
                          (datasource.data_header
                            ? datasource.data_header.tlc_create
                            : '') || isKeuangan)
                      )
                    "
                    type="dashed"
                    icon="edit"
                    class="width-full"
                    @click="
                      handleEdit(
                        datasource.data_header.id_account_pay,
                        datasource.data_header.jenis_transaksi
                      )
                    "
                    >Edit</a-button
                  >
                  <a-button
                    :disabled="
                      !(
                        datasource.last_status == 'Revised' &&
                        getAuth.username ==
                          (datasource.data_header
                            ? datasource.data_header.tlc_create
                            : '')
                      )
                    "
                    type="dashed"
                    icon="close-square"
                    class="width-full margin-top"
                    :loading="loading.cancel"
                    @click="
                      handleCancel(
                        datasource.data_header.id_account_pay,
                        datasource.data_header.jenis_transaksi
                      )
                    "
                    >Cancel</a-button
                  >
                </li>
              </ul>
              <a-button icon="more">Action</a-button>
            </a-popover>
          </template>

          <div class="m-card-body">
            <ul class="m-list-wrapper bordered">
              <li>
                <span class="m-list-title" for>Date Of AP</span>
                <span class="m-list-desc">{{
                  moment(
                    datasource.data_header
                      ? datasource.data_header.tgl_buat
                      : null
                  ).format(getDefaultDateFormat)
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>No. PO/WO/Adendum</span>
                <span class="m-list-desc">{{
                  datasource.data_header
                    ? datasource.data_header.no_transaksi
                    : "-"
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Supplier</span>
                <span class="m-list-desc">{{
                  datasource.data_header
                    ? datasource.data_header.nama_supplier
                    : "-"
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Nama Bank/No.Rekening</span>
                <span class="m-list-desc">{{
                  `${
                    datasource.data_header ? datasource.data_header.bank : "-"
                  } / ${
                    datasource.data_header
                      ? datasource.data_header.no_rekening
                      : "-"
                  }`
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>No. Invoice</span>
                <span class="m-list-desc">{{
                  datasource.data_header
                    ? datasource.data_header.no_invoice
                    : "-"
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Date Of Invoice</span>
                <span class="m-list-desc">{{
                  moment(
                    datasource.data_header
                      ? datasource.data_header.tgl_invoice
                      : null
                  ).format(getDefaultDateFormat)
                }}</span>
              </li>
              <li>
                <span class="m-list-title">{{
                  `Due Date(${dueDays >= 0 ? dueDays : 0} day/s)`
                }}</span>
                <span class="m-list-desc">{{
                  moment(
                    datasource.data_header
                      ? datasource.data_header.due_date
                      : null
                  ).format(getDefaultDateFormat)
                }}</span>
              </li>
              <li v-if="datasource.data_header.cc_no">
                <span class="m-list-title" for>Credit Card</span>
                <span class="m-list-desc">{{
                  `${datasource.data_header.cc_no} | ${datasource.data_header.cc_tlc}`
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Description</span>
                <span class="m-list-desc">{{
                  datasource.data_header
                    ? datasource.data_header.description
                    : "-"
                }}</span>
              </li>
              <li>
                <span class="m-list-title" for>Note</span>
                <span class="m-list-desc">{{
                  datasource.data_header ? datasource.data_header.catatan : "-"
                }}</span>
              </li>
              <li class="m-display-flex space-between align-middle">
                <span class="m-list-title" for>File Document</span>
                <span class="m-list-desc">
                  <a-button icon="eye" @click="handleViewDoc()">
                    {{ getScreen ? "" : "View Document" }}
                  </a-button>
                </span>
              </li>
            </ul>
          </div>
        </a-card>

        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Details</h4>
            </div>
            <a-input-search
              v-model="search"
              placeholder="Quick Search"
              allowClear
              :change="searching"
              class="margin-bottom"
            />
            <a-table
              :rowKey="
                (record, index) => {
                  return index;
                }
              "
              :columns="columns"
              :dataSource="datasource.dtl_manifest"
              :pagination="pagination"
              size="small"
              bordered
              :scroll="{ x: 950 }"
            >
              <span slot="no" slot-scope="text, data, index">
                {{ index + 1 }}
              </span>
              <span slot="item" slot-scope="item">
                <b>{{ item.nama_item }}</b>
                <br /><i>({{ item.type_item }})</i>
              </span>
              <span slot="ppdtl" slot-scope="ppdtl">
                {{ ppdtl.powo_nm }}
              </span>
              <span slot="values" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="
                    datasource.datahader ? datasource.datahader.mata_uang : null
                  "
                  :valueNumber="item.bearer_tax=='1' ? (!itemIsPresent? item.price : (item.price*-1)) : item.price"
                />
              </span>
              <span slot="total_values" slot-scope="item">
                <CurrencyJustified
                  :currencyValue="
                    datasource.datahader ? datasource.datahader.mata_uang : null
                  "
                  :valueNumber="item.bearer_tax=='1' ? (!itemIsPresent ? (item.price * item.quantity) : (item.price * item.quantity * -1)) : (item.price * item.quantity)"
                />
              </span>
              <span slot="doc_tax" slot-scope="item">
                <div style="text-align: center;">
                  <a-button
                    icon="edit"
                    size="small"
                    :type="
                      item.kode_setoran_pajak != null &&
                      item.kode_setoran_pajak != null
                        ? 'primary'
                        : 'danger'
                    "
                    style="margin-right:5px"
                    @click="handleShowTaxModal(item)"
                    v-if="
                      isTaxOfficer &&
                        datasource.jenis == 'Verifikator' &&
                        item.kategori == '2' &&
                        item.type_tax != 'bea_masuk'
                    "
                  >
                  </a-button>

                  <a-button
                    icon="file"
                    disabled
                    size="small"
                    v-if="
                      item.kategori == '2' &&
                        item.document_tax == 'No File Uploaded'
                    "
                  >
                  </a-button>
                  <a-button
                    icon="file"
                    @click="handleViewDocLink(item)"
                    size="small"
                    v-if="
                      item.kategori == '2' &&
                        item.document_tax != 'No File Uploaded'
                    "
                  >
                  </a-button>
                </div>
              </span>
              <div class="m-price-total" slot="footer">
                <a-statistic
                  title="Total"
                  :value="
                    formatCurrency(
                      datasource.data_header
                        ? datasource.data_header.mata_uang
                        : 'IDR',
                      datasource.data_header ? datasource.data_header.value : 0
                    )
                  "
                  class="margin-top m-text-align
                right"
                />
              </div>
            </a-table>
          </a-collapse-panel>
        </a-collapse>

        <a-card
          class="margin-top"
          v-if="datasource.jenis === 'Transfer' && status_transfer"
        >
          <div slot="title">
            Manifest Actions &nbsp;<i
              v-if="datasource.jenis == 'Transfer' && !status_transfer"
              style="color:red!important"
              >(Funding has not been set)</i
            >
          </div>
          <div class="m-text-align right margin-remove" slot="extra">
            <h5 class="m-text-align right margin-remove">
              remaining balance
            </h5>
            <a-tag color="green" class="m-text-align right margin-remove">{{
              formatCurrency(currency, sisa_tf)
            }}</a-tag>
          </div>
          <template v-if="!(source.jenis == 'Transfer' && !status_transfer)">
            <a-form :form="form">
              <a-row :gutter="16">
                <a-form-item label="Status">
                  <a-select
                    @change="onChangeStatus"
                    v-decorator="[
                      'status',
                      {
                        rules: [{ required: true }],
                        initialValue: datasource.aksi[0].aksi,
                      },
                    ]"
                  >
                    <a-select-option
                      v-for="da in datasource.aksi"
                      :key="da.aksi"
                      >{{ da.aksi }}</a-select-option
                    >
                  </a-select>
                </a-form-item>

                <a-form-item v-if="reqFileTf" label="Transfer Date">
                  <a-date-picker
                    placeholder="Select Date"
                    :format="dateFormat"
                    v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                  />
                </a-form-item>

                <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                  <a-upload
                    :fileList="fileList"
                    :disabled="fileList.length > 0"
                    v-decorator="[
                      'file_transfer',
                      { rules: [{ required: reqFileTf }] },
                    ]"
                    accept=".jpg, .png, .pdf"
                    :remove="handleRemove"
                    :beforeUpload="beforeUpload"
                  >
                    <a-button> <a-icon type="upload" />Select File </a-button>
                  </a-upload>
                </a-form-item>

                <a-form-item v-if="reqFileTf" label="Transfer Value">
                  <a-checkbox
                    :defaultChecked="true"
                    @change="onchangeNilaiTf"
                    :checked="checkTransferValue"
                    >Transfer value according to remaining balance</a-checkbox
                  >
                  <a-input-number
                    :min="0.1"
                    :max="sisa_tf"
                    class="m-display-block"
                    v-decorator="[
                      'value_transferan',
                      {
                        rules: [{ required: true }],
                        initialValue: temp_sisa_tf,
                      },
                    ]"
                    :disabled="disableNilaiTf"
                  ></a-input-number>
                </a-form-item>

                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan', { rules: [{ required: false }] }]"
                  />
                </a-form-item>
              </a-row>
              <a-form-item :wrapper-col="{ span: 24 }">
                <a-button
                  @click="handleActionConfirm"
                  block
                  type="primary"
                  html-type="submit"
                  :loading="loading.trans_verif"
                  >Save</a-button
                >
              </a-form-item>
            </a-form>
          </template>
        </a-card>

        <a-card
          class="margin-top"
          v-if="
            datasource.jenis === 'Verifikator' || datasource.jenis === 'Approve'
          "
        >
          <div slot="title">Manifest Actions</div>

          <a-form :form="form">
            <a-form-item label="Note">
              <a-textarea
                placeholder="Write the note here ... "
                :rows="4"
                v-decorator="['catatan']"
              />
            </a-form-item>
            <a-form-item label="Aksi">
              <a-select
                v-decorator="[
                  'aksi',
                  {
                    rules: [{ required: true }],
                    initialValue: datasource.aksi[0].aksi,
                  },
                ]"
              >
                <a-select-option
                  v-for="item in datasource.aksi"
                  :key="item.aksi"
                  >{{ item.aksi }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-button
                @click="handleActionConfirm"
                block
                type="primary"
                html-type="submit"
                :loading="loading.trans_verif"
                >Save</a-button
              >
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>

      <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
        <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Status</h4>
              <div>
                <Status :status="datasource.last_status" />
                <a-button
                  @click="historyToggle"
                  type="default"
                  size="small"
                  class="margin-right-small"
                >
                  <a-icon type="history" />
                </a-button>
              </div>
            </div>
            <a-timeline class="m-timeline">
              <a-timeline-item color="green">
                <div class="m-timeline-title">
                  Pembuat -
                  {{
                    datasource.data_header
                      ? datasource.data_header.tlc_create
                      : ""
                  }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove">
                    {{
                      moment(
                        datasource.data_header
                          ? datasource.data_header.create_dt
                          : null
                      ).format(getDateTimeFormat)
                    }}
                  </h4>
                  <span
                    class="m-text-small"
                    v-if="
                      datasource.data_header
                        ? datasource.data_header.catatan
                        : null
                    "
                    >{{ datasource.data_header.catatan }}</span
                  >
                  <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                </div>
                <div class="m-timeline-footer">
                  <a-tag color="green">Created</a-tag>
                </div>
              </a-timeline-item>
              <a-timeline-item
                v-for="workflow in datasource.status_app"
                :key="workflow.step_no"
              >
                <div class="m-timeline-title">
                  {{ workflow.actor }}
                  {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                    {{
                      moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                    }}
                  </h4>
                  <span class="m-text-small" v-if="workflow.remark">{{
                    workflow.remark
                  }}</span>
                  <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                </div>
                <div class="m-timeline-footer">
                  <Status :status="workflow.status" />
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-collapse-panel>
        </a-collapse>
        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Related Document</h4>
            </div>
            <a-list
              itemLayout="horizontal"
              :dataSource="datasource.data_dokumen_terkait"
            >
              <Empty
                v-if="
                  datasource.data_dokumen_terkait
                    ? datasource.data_dokumen_terkait.length <= 0
                    : datasource.data_dokumen_terkait
                "
              />
              <a-list-item slot="renderItem" slot-scope="item">
                <a-list-item-meta>
                  <div
                    slot="title"
                    class="m-display-flex flex-column align-top"
                  >
                    <Status
                      :class="!getScreen ? 'margin-remove' : ''"
                      :status="item.status"
                    />
                    <a @click="handleDocument(item)"
                      >{{ item.header }} | {{ item.tlc }}</a
                    >
                  </div>
                  <template slot="description">
                    <span>{{ item.no_manifest }}</span>
                  </template>
                </a-list-item-meta>
              </a-list-item>
            </a-list>
          </a-collapse-panel>
        </a-collapse>
      </a-col>
    </a-row>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="history" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in datasource.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>

    <TaxDepositEntry
      name="axDepositEntry"
      :v-if="visibleTaxModal"
      :visibleTaxModal="visibleTaxModal"
      :getType_tax="getType_tax"
      :getListsetoranpajak="datapajak.getListsetoranpajak"
      :getListobjekpajak="datapajak.getListobjekpajak"
      :tax_type="datapajak.tax_type"
      :file_document_tax="datapajak.file_document_tax"
      :kode_setoran_pajak="datapajak.kode_setoran_pajak"
      :objek_pajak="datapajak.objek_pajak"
      :id_header="datapajak.id_header"
      :id_dtl="datapajak.id_dtl"
      :dpp_value="datapajak.dpp_value"
      :value="datapajak.value"
      :file="datapajak.fileList"
      jenis_transaksi="account_pay"
      :hideUploadDocTax="true"
    />
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import dueDateCalc from "@/mixins/dueDateCalc.js";
import Status from "@/components/Status.vue";
import HandleRoute from "@/mixins/HandleRoute";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import TaxDepositEntry from "@/components/TaxDepositEntry.vue";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "manifest-ap",
  mixins: [dueDateCalc, HandleRoute, CurrencyFormat, GlobalMethod],
  components: {
    Status,
    TaxDepositEntry,
  },
  data() {
    return {
      visiblemenupopover: false,
      datasource: {
        loading: false,
        dtl_manifest: [],
        dtl_manifestOri: [],
        datapajak: {
          getListsetoranpajak: {},
          getListobjekpajak: {},
          tax_type: "",
          file_document_tax: null,
          kode_setoran_pajak: "",
          objek_pajak: "",
          id_header: "",
          id_dtl: "",
          status_transfer: false,
        },
      },
      dueDays: 0,
      visibleHistory: false,
      search: undefined,
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      visibleTaxModal: false,
      datapajak: {
        getListsetoranpajak: {},
        getListobjekpajak: {},
        tax_type: "",
        file_document_tax: null,
        kode_setoran_pajak: "",
        objek_pajak: "",
        id_header: "",
        id_dtl: "",
      },
      loading: {
        cancel: false,
        trans_verif: false,
        page: false,
      },
    };
  },
  mounted() {
    Event.$on("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$on("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    Event.$on("confirmMessageReturn", this.handleAction);
  },
  beforeDestroy() {
    Event.$off("TaxDepositEntryCancel", this.taxDepositEntryCancel);
    Event.$off("TaxDepositEntryUpdate", this.taxDepositEntryUpdate);
    Event.$off("confirmMessageReturn", this.handleAction);
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetch();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getDefaultDateFormat",
      "getAuth",
      "getDateTimeFormat",
      "getType_tax",
    ]),
    searching() {
      if (this.search) {
        this.datasource.dtl_manifest = this.datasource.dtl_manifestOri.filter(
          (obj) =>
            obj.item_name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (!this.search) {
        this.datasource.dtl_manifest = this.datasource.dtl_manifestOri;
      }
      return true;
    },
    columns() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "No",
          key: "no",
          width: 60,
          align: "right",
          scopedSlots: { customRender: "no" },
          sorter: (a, b) => a.no - b.no,
        },
        {
          title: "Item Name",
          width: 200,
          key: "item_name",
          scopedSlots: { customRender: "item" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Invoice Detil",
          width: 200,
          key: "ppdtl",
          scopedSlots: { customRender: "ppdtl" },
          sorter: (a, b) => a.item_name.length - b.item_name.length,
        },
        {
          title: "Quantity",
          dataIndex: "quantity",
          key: "quantity",
          width: 100,
          sorter: (a, b) => a.quantity.length - b.quantity.length,
        },

        {
          title: "Unit Price",
          key: "values",
          scopedSlots: { customRender: "values" },
          width: 100,
        },
        {
          title: "Amount",
          key: "total_values",
          scopedSlots: { customRender: "total_values" },
          width: 100,
        },
        {
          title: "Tax Deposit",
          key: "doc_tax",
          fixed: "right",
          align: "right",
          scopedSlots: { customRender: "doc_tax" },
          width: 100,
        },
      ];
      return kolom;
    },
    isTaxOfficer() {
      let data = _.filter(
        this.getAuth.nama_bidang,
        (obj) => obj == "Tax Officer"
      );
      return data.length > 0 ? true : false;
    },
    isValidTaxOfficerValue() {
      let data = _.filter(
        this.datasource.dtl_manifestOri,
        (obj) =>
          obj.is_tax == "1" &&
          obj.kode_setoran_pajak == null &&
          obj.type_tax &&
          obj.type_tax != "bea_masuk"
      );
      return data.length > 0 ? false : true;
    },
    itemIsPresent() {
      let result = false;
      if (this.datasource.dtl_manifestOri) {
        let dta = _.filter(this.datasource.dtl_manifestOri,
          (obj) => "0" == obj.used_for);
        if (dta.length > 0)
          result = true;
      }

      return result;
    },
    isKeuangan(){
      let data = _.filter(this.getAuth.nama_bidang,(obj) => obj=="Keuangan");
      return data.length>0 ? true : false;
    },
  },
  methods: {
    moment,
    fetch() {
      this.loading.page = true;
      this.$store
        .dispatch("getManifest", { id: this.$attrs.id })
        .then((res) => {
          this.datasource = res;
          this.datasource.data_header = res.data_header[0];
          this.dueDays = this.dateCalculation(
            this.datasource.data_header.due_date
          );
          this.datasource.jenis = res.jenis;
          this.datasource.dtl_manifest = res.data_dtl;
          this.datasource.dtl_manifestOri = res.data_dtl;
          this.datasource.history = res.notifikasi;
          this.datasource.last_status = res.status_besar;
          this.datasource.setoran_pajak = res.setoran_pajak;
          this.status_transfer = res.status_transfer;
          this.datasource.aksi = res.aksi;
          this.loading.page = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading.page = false;
        });
    },
    handleDocument(item) {
      const data = {
        rest_api: item.rest_api.toLowerCase(),
        id_manifest: item.id_manifest,
        tlc: this.getAuth.username,
        user_pembuat: item.user_pembuat,
      };
      this.handleView(data);
    },
    handleViewDoc() {
      window.open(this.$serviceUrl + this.datasource.data_header.link);
    },
    historyToggle(e) {
      this.visibleHistory = !this.visibleHistory;
      e.stopPropagation();
    },
    taxDepositEntryCancel() {
      this.visibleTaxModal = false;
    },
    taxDepositEntryUpdate(val) {
      let index1 = _.findIndex(this.datasource.dtl_manifestOri, {
        id_dtl: val.id_dtl,
      });
      this.datasource.dtl_manifestOri[index1].file_doc_tax = val.document_tax;
      this.datasource.dtl_manifestOri[index1].document_tax = val.document_tax;
      this.datasource.dtl_manifestOri[index1].document_path = val.document_path;
      this.datasource.dtl_manifestOri[index1].tax_value = val.tax_value;
      this.datasource.dtl_manifestOri[index1].kode_objek_pajak =
        val.objek_pajak;
      this.datasource.dtl_manifestOri[index1].kode_setoran_pajak =
        val.kode_setoran_pajak;
      let index2 = _.findIndex(this.datasource.dtl_manifest, {
        id_dtl: val.id_dtl,
      });
      this.datasource.dtl_manifestOri[index2].file_doc_tax = val.document_tax;
      this.datasource.dtl_manifestOri[index2].document_tax = val.document_tax;
      this.datasource.dtl_manifestOri[index2].document_path = val.document_path;
      this.datasource.dtl_manifestOri[index2].tax_value = val.tax_value;
      this.datasource.dtl_manifestOri[index2].kode_objek_pajak =
        val.objek_pajak;
      this.datasource.dtl_manifestOri[index2].kode_setoran_pajak =
        val.kode_setoran_pajak;
      this.datasource.dtl_manifestOri[index2].dpp_value = val.dpp_value;
    },
    handleShowTaxModal(item) {
      console.log(item);
      this.datapajak.tax_type = item.type_tax;
      this.datapajak.kode_setoran_pajak = item.kode_setoran_pajak;
      this.datapajak.objek_pajak = item.kode_objek_pajak;
      this.datapajak.id_header = item.id_hdr;
      this.datapajak.id_dtl = item.id_dtl;
      this.datapajak.dpp_value = item.dpp_value;
      this.datapajak.value = item.tax_value;
      this.datapajak.getListsetoranpajak = _.filter(
        this.datasource.setoran_pajak,
        (obj) => obj.id_type_tax == item.type_tax
      );
      this.datapajak.getListobjekpajak = _.filter(
        this.datasource.objek_pajak,
        (obj) => obj.id_type_tax == item.type_tax
      );

      if (
        item.file_doc_tax != null &&
        item.file_doc_tax != "No File Uploaded"
      ) {
        let typefile = this.fileTypeFromUrl(item.file_doc_tax);
        let file = this.dataURLtoFile(
          typefile + item.document_file,
          item.file_doc_tax
        );
        file.uid = "vc-upload-1-1";
        file.status = "done";
        file.url = this.$serviceUrl + item.document_path;
        this.datapajak["fileList"] = [];
        this.datapajak.fileList.push(file);
      }
      this.visibleTaxModal = true;
    },
    handleViewDocLink(item) {
      window.open(this.$serviceUrl + item.document_path);
    },
    handleActionConfirm() {
      let sts = this.form.getFieldValue("aksi");
      if (sts == "Verified" && this.isValidTaxOfficerValue) {
        this.confirmMessage("confirm-save");
      } else if (sts !== "Verified") {
        this.confirmMessage("confirm-save");
      } else {
        this.displayMessageValue(
          "error-other",
          "There is still Document Tax data that hasn't been filled in!"
        );
      }
    },
    handleEdit(id, jns_transaksi) {
      this.$router.push({
        name: "account-pay-edit",
        params: { type: jns_transaksi == "PO" ? "1" : "2", id: id },
      });
    },
    handleCancel() {
      this.loading.cancel = true;
      let data = new FormData();
      data.append("tlc", this.getAuth.username);
      data.append("id_manifest", this.datasource.data_header.id_account_pay);
      data.append(
        "jenis_trans",
        this.datasource.data_header.jenis_transaksi == "Adendum"
          ? "adendum"
          : "account_pay"
      );
      data.append("code_trans", this.datasource.data_header.no_ap);
      let code = this.datasource.data_header.no_ap.split("/");
      data.append("kode_project", code[2]);
      this.asyncAxiosPost(
        "main/cancel_transaction",
        "formdata",
        this.getAuth,
        data
      )
        .then((response) => {
          this.displayMessage("success-cancel");
          this.loading.cancel = false;

          this.$router.go(-1);
        })
        .catch((err) => {
          this.loading.cancel = false;
          let response = Object.assign({}, err.response);
          if (response.data.status == false && response.data.message) {
            this.displayMessageValue("error-other", response.data.message);
          } else {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
          }
        });
    },
    handleAction() {
      if (this.datasource.jenis === "Transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            return;
          }
          this.loading.trans_verif = true;
          let formData = new FormData();
          formData.append("tlc", this.getAuth.username);
          formData.append("id_manifest", this.$attrs.id);
          formData.append("file_transfer", values.file_transfer.file);
          formData.append("remark", values.catatan);
          formData.append("status", "Transferred");
          formData.append(
            "tgl_transferan",
            moment(values.tgl_tf).format(this.getStandartFormatDate)
          );

          if (this.checkTransferValue) {
            formData.append("cek_value", 1);
            formData.append("value_transferan", 0);
          } else {
            formData.append("cek_value", 0);
            formData.append("value_transferan", values.value_transferan);
          }

          Axios({
            method: "post",
            url: this.$serviceUrl + "account_pay/approval",
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go(0);
            })
            .catch((err) => {
              console.log("error : " + err);
              this.loading.trans_verif = false;
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");

            return;
          }

          this.loading.trans_verif = true;
          Axios({
            method: "post",
            url: this.$serviceUrl + "account_pay/approval",
            processData: false,
            data: {
              id_manifest: this.$attrs.id,
              tlc: this.getAuth.username,
              status: values.aksi,
              remark: values.catatan ? values.catatan : "",
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              /* this.$router.push({ name: "po" }); */
              this.$router.go(0);
            })
            .catch((err) => {
              this.loading.trans_verif = false;
              console.log("error : " + err);
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error-other", responses.message);
            });
        });
      }
    },
  },
};
</script>

<style></style>
